// extracted by mini-css-extract-plugin
export default {"stickableHeader":"Details_stickableHeader__NmNhZ","shadow":"Details_shadow__XSDx2","table":"Details_table__MqQhx","placeHolderShimmer":"Details_placeHolderShimmer__2kBw-"};